export const ADDRESS_TYPE = {
  BUSINESS: 1,
  HOME: 2,
  MAILING: 3,
  POSTAL: 2,
};
